module.exports = __webpack_public_path__ + "images/promo-banner-background.png";